module.exports = __webpack_public_path__ + "static/media/download-apple-store.610dbff1.png";